module.exports = __webpack_public_path__ + "static/8-daily-backups-of-your-data-60ea8142311ffb6399d8f4fe71f41e02.jpg";